import type { Emitter } from 'mitt'
import mitt from 'mitt'

type Events = {
  emitterUploadSuccess: string
  getLoginPage: string
  voiceOperate: string
  emitUploadProgress: number
  emitMusicCurrentPlay: {
    index?: number
    originType?: MusicOriginType
  }
}

export const emitter: Emitter<Events> = mitt<Events>()
